module.exports = __webpack_public_path__ + "static/my-american-journey-0ef92bff8af9cf9ee9bd747fba0ef988.jpg";